// extracted by mini-css-extract-plugin
export default {"commentForm":"commentsWrapper_commentForm__xOLeT","createComment":"commentsWrapper_createComment__WiHv1"};